import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Loading from '../../Common/Loading';
import CustomAlert from '../../Common/CustomAlert';
import popup_bg from '../../Common/Images/ImagesForAlert/popup_bg1.png';
import alert_close_n from '../../Common/Images/ImagesForAlert/alert_close_n.png';
import alert_close_o from '../../Common/Images/ImagesForAlert/alert_close_o.png';
import popimg from "../../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../../Common/Images/ImagesForAlert/popup_close_n.png";
import { useNavigate } from 'react-router-dom';


const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

const styles = {
    container: { 
        position: 'absolute' as 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        display: 'flex', flexDirection: 'column' as 'column',
        fontFamily: 'Arial', fontSize: '12pt', 
        backgroundColor: '#FFFFFF', overflow: 'hidden' 
    },
    headerSection: {
        padding: '5px 10px',
        backgroundColor: '#2f6089', 
        color: '#FFFFFF',
        fontWeight: 'bold' as 'bold',
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        borderBottom: '1px solid #000000',
        flexShrink: 0,
        // fontFamily: 'Trebuchet MS, Arial, sans-serif',
        fontSize: '12pt',
        height: '25px'
    },
    filterSection: {
        padding: '8px',
        backgroundColor: '#EBE9FD',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap' as 'wrap'
    },
    tableContainer: { 
        flex: 1,
        overflow: 'auto',
        backgroundColor: '#FFFFFF'
    },
    dataTable: { 
        width: '100%', 
        borderCollapse: 'collapse' as 'collapse', 
        fontSize: '12pt', 
        border: '1px solid #80a0ff' 
    },
    th: { 
        fontFamily: 'Arial',
        backgroundColor: '#C7DDFD',
        color: '#2859ac',
        fontSize: '12pt',
        padding: '8px',
        fontWeight: 'normal' as 'normal',
        border: '1px solid #80a0ff',
        textAlign: 'left' as 'left',
        position: 'sticky' as 'sticky',
        top: 0,
        zIndex: 1
    },
    td: { 
        padding: '8px',
        fontFamily: 'Arial',
        fontSize: '10pt',
        borderRight: '1px solid #80a0ff',
        color: 'black' 
    },
    label: {
        fontWeight: 'normal' as 'normal',
        marginRight: '5px',
        fontSize: '10pt',
        // fontFamily: 'Verdana',
        verticalAlign: 'middle',
        color: '#000'
    },
    input: {
        fontFamily: 'Arial',
        fontSize: '11px',
        padding: '1px',
        border: '1px solid #80a0ff',
        marginRight: '5px'
    },
    button: {
        // fontFamily: 'Trebuchet MS',
        height: '28px',
        width : '100px',
        padding: '2px 10px',
        color: '#FFFFFF',
        cursor: 'pointer',
        fontSize: '10pt',
        fontWeight: 'bold' as 'bold',
        marginRight: '20px'
    },
    closeLink: {
        color: '#FFFFFF',
        textDecoration: 'underline',
        cursor: 'pointer',
        fontSize: '11px',
        fontWeight: 'normal' as 'normal'
    },
    popupHeader: {
        backgroundImage: `url(${popup_bg})`,
        backgroundSize: '100% 100%',
        height: '30px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: '10px',
        flexShrink: 0
    },
    popupTitle: {
        color: 'white',
        fontWeight: 'bold' as 'bold',
        fontSize: '11pt',
        fontFamily: 'Arial'
    },
    buttonGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 100px)',
        gap: '5px',
        marginRight: '20px'
    },
    centerLabel: {
        flex: 1,
        textAlign: 'center' as 'center',
        fontSize: 'larger',
        color: 'teal',
        fontWeight: 'bold' as 'bold',
        // fontFamily: 'Trebuchet MS'
    },
    periodRow: {
        width: '100%',
        padding: '5px 10px',
        borderTop: '1px solid #80a0ff',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#EBE9FD'
    },
    legacyBtn: {
        padding: '2px 5px',
        fontSize: '11px',
        cursor: 'pointer',
        backgroundColor: '#f0f0f0',
        border: '1px solid #80a0ff'
    },
    navButton: {
        marginLeft: '5px',
        color: "#2859ac",
        fontWeight: "bold" as "bold",
        cursor: 'pointer',
        padding: '2px 5px',
        border: '1px solid #80a0ff',
        backgroundColor: '#f0f0f0'
    },
    footer: {
        marginTop: 'auto',
        backgroundColor: '#C7DDFD',
        padding: '8px 10px',
        borderTop: '1px solid #80a0ff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'Arial',
        fontSize: '10pt',
        color: '#2859ac',
        fontWeight: 'bold' as 'bold',
        flexShrink: 0
    },
    navLink: {
        cursor: 'pointer',
        margin: '0 8px',
        userSelect: 'none' as 'none',
        color: '#2859ac',
        textDecoration: 'underline'
    },
    refreshLink: {
        color: 'blue',
        textDecoration: 'underline',
        cursor: 'pointer',
        fontWeight: 'normal' as 'normal',
        marginRight: '20px',
        marginLeft: '5px'
    }
};

interface LoginReportItem {
    userName: string;
    loginTime: string;
    logoutTime: string;
    userCategory: string;
    browser: string;
    usedTime: string;
    howLoggedIn: string;
    howLoggedOut: string;
    os: string;
    schoolCode?: string;
    familyCode?: string;
    login?: string;
}

interface Props {
    schoolCode?: string;
    familyCode?: string;
    login?: string;
    onBack?: () => void;
}

const EL_LoginUsage: React.FC<Props> = ({ schoolCode: propSchoolCode, familyCode: propFamilyCode, login: propLogin, onBack }) => {
    const [searchParams] = useSearchParams();
    const [isSubmitHover, setIsSubmitHover] = useState(false);
    const [isCloseHover, setIsCloseHover] = useState(false);

    const schoolCodeParam = propSchoolCode || searchParams.get('SchoolCode') || '';
    const familyCodeParam = propFamilyCode || searchParams.get('FamilyCode') || '';
    const loginParam = propLogin || searchParams.get('Login') || '';
    
    const [dateMode, setDateMode] = useState('Today'); 
    const [fromDate, setFromDate] = useState('');
    const [fromTime, setFromTime] = useState('00:00');
    const [toTime, setToTime] = useState('23:59');
    const [toDate, setToDate] = useState('');
    const [sortBy, setSortBy] = useState('0');
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const [tempRowsInput, setTempRowsInput] = useState(rowsPerPage.toString());

    const [reportData, setReportData] = useState<LoginReportItem[]>([]);
    const [loading, setLoading] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '' });

    const navigate = useNavigate()

    useEffect(() => {
        const initDates = () => {
            const today = new Date();
            const y = today.getFullYear();
            const m = String(today.getMonth() + 1).padStart(2, '0');
            const d = String(today.getDate()).padStart(2, '0');
            const todayStr = `${y}-${m}-${d}`;

            setFromDate(todayStr);
            setToDate(todayStr);

        };
        initDates();
    }, []);

    const handlePageChange = (direction: 'prev' | 'next' | 'first' | 'last') => {
        const totalPages = Math.ceil(reportData.length / rowsPerPage);
        switch (direction) {
            case 'prev': setCurrentPage(prev => Math.max(prev - 1, 1)); break;
            case 'next': setCurrentPage(prev => Math.min(prev + 1, totalPages)); break;
            case 'first': setCurrentPage(1); break;
            case 'last': setCurrentPage(totalPages); break;
        }
    };

    const handleDateModeChange = (mode: string) => {
        setDateMode(mode);
        const today = new Date();
        let start = new Date(today);
        let end = new Date(today);

        const toLocalISO = (date: Date) => {
            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, '0');
            const d = String(date.getDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        };
      
        switch (mode) {
            case 'Today': break;
            case 'Yesterday':
                start.setDate(today.getDate() - 1);
                end.setDate(today.getDate() - 1);
                break;
            case 'ThisWeek':
                start.setDate(today.getDate() - today.getDay());
                break;
            case 'LastWeek':
                start.setDate(today.getDate() - today.getDay() - 7);
                end.setDate(today.getDate() - today.getDay() - 1);
                break;
            case 'ThisMonth':
                start = new Date(today.getFullYear(), today.getMonth(), 1);
                break;
            case 'LastMonth':
                start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                end = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case 'Period': return;
        }
      
        const startStr = toLocalISO(start);
        const endStr = toLocalISO(end);
      
        setFromDate(startStr);
        setToDate(endStr);
      
    };

    const fetchReportInternal = async (fDate: string, fTime: string, tDate: string, tTime: string) => {
        setLoading(true);
        try {
            const cleanFromTime = (fTime || "00:00").trim();
            const cleanToTime = (tTime || "23:59").trim();
        
            const formatTime = (time: string, isEnd: boolean) => {
                const parts = time.split(':');
                if (parts.length === 1) return `${time}:00:00`;
                if (parts.length === 2) return `${time}:${isEnd ? '59' : '00'}`;
                return time;
            };
          
            const fullFromDate = `${fDate} ${formatTime(cleanFromTime, false)}`;
            const fullToDate = `${tDate} ${formatTime(cleanToTime, true)}`;
          
            const payload = {
                schoolCode: schoolCodeParam,
                familyCode: familyCodeParam,
                login: loginParam,
                fromDate: fullFromDate,
                toDate: fullToDate,
                sortBy: sortBy
            };
          
            const response = await fetch(`${API_BASE_URL}api/webadmin/login-usage/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
          
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          
            const result = await response.json();
            if (result.success) {
                setReportData(result.data);
                setCurrentPage(1);
            } else {
                setAlertInfo({ show: true, message: result.message || 'Error fetching report' });
            }
        } catch (error) {
            console.error("Fetch error:", error);
            setAlertInfo({ show: true, message: 'Network error occurred' });
        } finally {
            setLoading(false);
        }
    };

    const handleManualSubmit = () => {
        fetchReportInternal(fromDate, fromTime, toDate, toTime);
    };

    const handleClose = () => {
        window.close();
    };

    const handleRefreshRows = () => {
        const newRows = parseInt(tempRowsInput);
        if (!isNaN(newRows) && newRows > 0) {
            setRowsPerPage(newRows);
            setCurrentPage(1);
        }
    };

    const isPeriod = dateMode === 'Period';

    const totalPages = Math.ceil(reportData.length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const currentResults = reportData.slice(startIndex, startIndex + rowsPerPage);

    return (
        <>
     
        <div style={styles.container} >
                     <div
                style={{
                    backgroundImage: `url(${popimg}), url(${popbg})`,
                    backgroundRepeat: "no-repeat, no-repeat",
                    backgroundPosition: "left center, right center",
                    backgroundSize: "30% 100%, 70% 100%",
                    height: "16px",
                    color: "white",
                    padding: "7px 0px",
                    fontWeight: "bold",
                    fontSize: "12pt",
                    fontFamily: "arial",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    // marginBottom: "10px",
                }}
            >
                <span style={{ marginLeft: "10px" }}>
                    Login Usage
                </span>
                <img
                    src={popclose}
                    alt="close"
                    height="30px"
                    style={{ cursor: "pointer" }}
                    // onClick={() => {
                    //     const urlParams = new URLSearchParams(window.location.search);
                    //     if (urlParams.get('From') === 'Sysadmin') {
                    //         navigate("/SysAdmin");
                    //     } else {
                    //         window.close();
                    //     }
                    // }}
                    onClick={() => window.close()}
                />
            </div>
            {onBack && (
                <div style={styles.popupHeader}>
                    <span style={styles.popupTitle}>Login Usage Report</span>
                    <img 
                        src={alert_close_n}
                        alt="Close"
                        style={{ cursor: 'pointer', height: '30px', width: '62px' }}
                        onMouseOver={(e) => e.currentTarget.src = alert_close_o}
                        onMouseOut={(e) => e.currentTarget.src = alert_close_n}
                        onClick={onBack} 
                    />
                </div>
            )}
            
            {loading && <Loading />}

            <div style={{ ...styles.filterSection, display: 'flex', alignItems: 'center', padding: '8px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, auto)', gap: '10px 20px', marginRight: '20px' }}>
                    <label style={{ ...styles.label, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        <input type="radio" name="dateMode" checked={dateMode === 'Today'} onChange={() => handleDateModeChange('Today')} style={{ marginRight: '5px' }} /> Today
                    </label>
                    <label style={{ ...styles.label, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        <input type="radio" name="dateMode" checked={dateMode === 'ThisWeek'} onChange={() => handleDateModeChange('ThisWeek')} style={{ marginRight: '5px' }} /> This Week
                    </label>
                    <label style={{ ...styles.label, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        <input type="radio" name="dateMode" checked={dateMode === 'ThisMonth'} onChange={() => handleDateModeChange('ThisMonth')} style={{ marginRight: '5px' }} /> This Month
                    </label>

                    <label style={{ ...styles.label, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        <input type="radio" name="dateMode" checked={dateMode === 'Yesterday'} onChange={() => handleDateModeChange('Yesterday')} style={{ marginRight: '5px' }} /> Yesterday
                    </label>
                    <label style={{ ...styles.label, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        <input type="radio" name="dateMode" checked={dateMode === 'LastWeek'} onChange={() => handleDateModeChange('LastWeek')} style={{ marginRight: '5px' }} /> Last Week
                    </label>
                    <label style={{ ...styles.label, cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        <input type="radio" name="dateMode" checked={dateMode === 'LastMonth'} onChange={() => handleDateModeChange('LastMonth')} style={{ marginRight: '5px' }} /> Last Month
                    </label>
                </div>

                <div style={{ flex: 1, textAlign: 'center', fontSize: '14pt', color: 'teal', fontWeight: 'bold', fontFamily:"Times New Roman" }}>
                    {/* {schoolCodeParam}{familyCodeParam ? ` - - ${familyCodeParam} Family` : ''} */}
                    {schoolCodeParam}
                </div>

                <div style={{  textAlign: 'right'}}>
                    <button
                        style={{
                            ...styles.button,
                            marginRight: "10px",
                            backgroundColor: isSubmitHover ? 'orange' : '#119ECC',
                            border: `2px solid ${isSubmitHover ? '#119ECC' : 'orange'}`
                        }}
                        onMouseEnter={() => setIsSubmitHover(true)}
                        onMouseLeave={() => setIsSubmitHover(false)}
                        onClick={handleManualSubmit}
                    >
                        Submit
                    </button>
                    <button
                        style={{
                            ...styles.button,
                            marginTop: '5px',
                            marginRight: 0,
                            backgroundColor: isCloseHover ? 'orange' : '#119ECC',
                            border: `2px solid ${isCloseHover ? '#119ECC' : 'orange'}`
                        }}
                        onMouseEnter={() => setIsCloseHover(true)}
                        onMouseLeave={() => setIsCloseHover(false)}
                        onClick={handleClose}
                    >
                        Close
                    </button>
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', padding: '8px', backgroundColor: '#EBE9FD', borderBottom: '1px solid #CCC' }}>
                <label style={{ ...styles.label, cursor: 'pointer', display: 'flex', alignItems: 'center',fontSize:"11pt" }}>
                    <input type="radio" name="dateMode" checked={dateMode === 'Period'} onChange={() => setDateMode('Period')} style={{ marginRight: '5px', fontSize:"10pt" }} /> Select Period
                </label>

                <span style={{ ...styles.label, marginLeft: '20px',fontSize:"11pt" }}>From Date:</span>
                <input type="date" value={fromDate} disabled={dateMode !== 'Period'} onChange={(e) => setFromDate(e.target.value)} style={{...styles.input, fontSize:"10pt"}} />

                <span style={{ ...styles.label, marginLeft: '10px',fontSize:"11pt" }}>Time</span>
                <input type="text" value={fromTime} disabled={dateMode !== 'Period'} onChange={(e) => setFromTime(e.target.value)} style={{ ...styles.input, width: '70px', fontSize:"10pt" }} maxLength={8} />

                <span style={{ ...styles.label, marginLeft: '20px',fontSize:"11pt" }}>To Date</span>
                <input type="date" value={toDate} disabled={dateMode !== 'Period'} onChange={(e) => setToDate(e.target.value)} style={{...styles.input, fontSize:"10pt"}} />

                <span style={{ ...styles.label, marginLeft: '10px',fontSize:"11pt" }}>Time</span>
                <input type="text" value={toTime} disabled={dateMode !== 'Period'} onChange={(e) => setToTime(e.target.value)} style={{ ...styles.input, width: '70px', fontSize:"10pt" }} maxLength={8} />

                <span style={{ ...styles.label, marginLeft: '20px',fontSize:"11pt" }}>Sort By:</span>
                <select 
                    style={{ ...styles.input, width: '220px', fontSize:"10pt" }} 
                    value={sortBy} 
                    onChange={(e) => setSortBy(e.target.value)}
                >
                    <option value="0">Login in Time (DESC)</option>
                    <option value="1">SchoolCode, FamilyCode, Login, Login in Time</option>
                </select>

              </div>

            <div style={styles.tableContainer}>
                {reportData.length > 0 ? (
                    <table style={styles.dataTable}>
                        <thead>
                            <tr>
                                <th rowSpan={2} style={{...styles.th, verticalAlign: 'bottom'}}>#</th>
                                <th rowSpan={2} style={{...styles.th, verticalAlign: 'bottom'}}>Name</th>
                                <th colSpan={2} style={{ ...styles.th, textAlign: 'center' }}>Logged Time (Local Time)</th>
                                <th rowSpan={2} style={{ ...styles.th, textAlign: 'center', verticalAlign: 'bottom' }}>Category</th>
                                <th rowSpan={2} style={{...styles.th, verticalAlign: 'bottom'}}>Browser</th>
                                <th rowSpan={2} style={{ ...styles.th, textAlign: 'center', verticalAlign: 'bottom' }}>Used(HH:MM:SS)</th>
                                <th rowSpan={2} style={{...styles.th, verticalAlign: 'bottom'}}>How Logged IN</th>
                                <th rowSpan={2} style={{...styles.th, verticalAlign: 'bottom'}}>How Logged OUT</th>
                                <th rowSpan={2} style={{...styles.th, verticalAlign: 'bottom'}}>O/S</th>
                            </tr>
                            <tr>
                                <th style={{ ...styles.th, top: '32px', textAlign: 'center' }}>IN</th>
                                <th style={{ ...styles.th, top: '32px', textAlign: 'center' }}>OUT</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentResults.map((row, index) => (
                                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#F4FAFF' : 'white' }}>
                                    <td style={styles.td}>{index + 1}</td>
                                    <td style={styles.td}>{row.userName}</td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>{row.loginTime}</td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>{row.logoutTime}</td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>{row.userCategory}</td>
                                    <td style={styles.td}>{row.browser}</td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>{row.usedTime}</td>
                                    <td style={styles.td}>{row.howLoggedIn}</td>
                                    <td style={styles.td}>{row.howLoggedOut}</td>
                                    <td style={styles.td}>{row.os}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                    </div>
                )}
            </div>

            {reportData.length > 0 && (
                <div style={styles.footer}>
                    <span>Rows per page: </span>
                    <input 
                        type="text" 
                        value={tempRowsInput}
                        onChange={(e) => setTempRowsInput(e.target.value)}
                        style={{ ...styles.input, width: '40px', textAlign: 'center', marginLeft: '5px' }}
                    />
                    <span style={styles.refreshLink} onClick={handleRefreshRows}>Refresh</span>

                    <span style={styles.navLink} onClick={() => handlePageChange('first')}>&lt;&lt;</span>
                    <span style={styles.navLink} onClick={() => handlePageChange('prev')}>&lt;</span>

                    <span style={{ margin: '0 5px', fontWeight: 'normal' }}>
                        {currentPage} of {totalPages || 1}
                    </span>

                    <span style={styles.navLink} onClick={() => handlePageChange('next')}>&gt;</span>
                    <span style={styles.navLink} onClick={() => handlePageChange('last')}>&gt;&gt;</span>
                </div>
            )}
            
            {alertInfo.show && (
                <CustomAlert 
                    message={alertInfo.message} 
                    onClose={() => setAlertInfo({ ...alertInfo, show: false })} 
                />
            )}
        </div>
        </>
    );
}

export default EL_LoginUsage;